import { render } from "./PricingIndex.vue?vue&type=template&id=6ba6093e"
import script from "./PricingIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Pricing/PricingIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ba6093e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ba6093e', __exports__)) {
    api.reload('6ba6093e', __exports__)
  }
  
  module.hot.accept("./PricingIndex.vue?vue&type=template&id=6ba6093e", () => {
    api.rerender('6ba6093e', render)
  })

}


export default __exports__